export { default as AlAmalLogo } from './almalLogo.webp';
export { default as ArabNews } from './ArabNews.webp';
export { default as ArabNewsHeader } from './arabNewsHeader.webp';
export { default as DisruptHeaderImage } from './DisruptHeaderImage.webp';
export { default as Forbeslogoblack } from './Forbeslogoblack.webp';
export { default as TechCrunchHeaderImage } from './TechCrunchHeaderImage.webp';
export { default as TechCrunchLogo } from './TechCrunchLogo.webp';
export { default as WamdaLogo } from './wamdaLogo.webp';
export { default as Waya } from './waya.webp';
export { default as ZawyaHeaderImage } from './ZawyaHeaderImage.webp';
export { default as ZawyaLogo } from './ZawyaLogo.webp';

export const News = [
  // {
  //   news_media_name: 'Disrupt',
  //   logo_image: ruire('./DisruptLogo.png'),
  //   header_image: ruire('./DisruptHeaderImage.jpg'),
  //   text: 'Egyptian online used car retailer Sylndr raises $12.6m pre-seed funding round',
  //   link: 'https://disrupt-africa.com/2022/05/25/egyptian-online-used-car-retailer-sylndr-raises-12-6m-pre-seed-funding-round/#prettyPhoto',
  // },
  {
    news_media_name: 'Tech Crunch',
    logo_image: 'TechCrunchLogo.png',
    header_image: 'TechCrunchHeaderImage.png',
    text: 'Sylndr, an online used-car retailer, raises $12.6M pre-seed to disrupt Egypt’s automotive market',
    link: 'https://techcrunch.com/2022/05/23/sylndr-a-used-car-retailer-raises-12-6m-pre-seed-to-disrupt-egypts-automotive-market/',
    logo_key: 'TechCrunchLogo',
    header_key: 'TechCrunchHeaderImage',
  },
  {
    news_media_name: 'Zawya',
    logo_image: 'ZawyaLogo.png',
    header_image: 'ZawyaHeaderImage.jpg',
    text: 'Egypt’s used-car online retailer Sylndr raises $12.6mln in pre-seed round',
    link: 'https://www.zawya.com/en/wealth/alternative-investments/egypts-used-car-online-retailer-sylndr-raises-126mln-in-pre-seed-wdcgb8uw',
    logo_key: 'ZawyaLogo',
    header_key: 'ZawyaHeaderImage',
  },
  {
    news_media_name: 'Forbes',
    logo_image: 'Forbeslogoblack.png',
    header_image: 'DisruptHeaderImage.jpg',
    text: 'Egypt’s Online Used Car Retailer Sylndr Raises $12.6M In Latest Funding Round',
    link: 'https://www.forbesmiddleeast.com/innovation/startups/egypts-online-used-car-retailer-sylndr-raises-%24126m-in-pre-seed-funding-round',
    logo_key: 'Forbeslogoblack',
    header_key: 'DisruptHeaderImage',
  },

  {
    news_media_name: 'Wamda',
    logo_image: 'wamdaLogo.png',
    header_image: 'DisruptHeaderImage.jpg',
    text: 'Sylndr raises $12.6 million pre-Seed round to scale its marketplace for used cars',
    link: 'https://www.wamda.com/ar/2022/05/sylndr-raises-12-6-million-pre-seed-round-scale-marketplace-used-cars-arabic',
    logo_key: 'WamdaLogo',
    header_key: 'DisruptHeaderImage',
  },
  {
    news_media_name: 'Arab News',
    logo_image: 'ArabNews.png',
    header_image: 'arabNewsHeader.png',
    text: 'Egypt online car retailer Sylndr raises $12.6m pre-seed round',
    link: 'https://www.arabnews.com/node/2087791/business-economy',
    logo_key: 'ArabNews',
    header_key: 'ArabNewsHeader',
  },
  // {
  //   news_media_name: 'Tekedia',
  //   logo_image: 'TekediaLogo.png',
  //   header_image: 'TekediaHeaderImage.jpg',
  //   text: 'Egyptian Used Car Startup, Sylndr, Raises $12.6m in Pre-seed Fund',
  //   link: 'https://www.tekedia.com/egyptian-used-car-startup-sylndr-raises-12-6m-in-pre-seed-fund/',
  // },
  // {
  //   news_media_name: 'ScoopEmpire',
  //   logo_image: 'scoopEmpire.png',
  //   header_image: 'DisruptHeaderImage.jpg',
  //   text: 'Exclusive: Founders Of Sylndr Discuss Raising $12.6 M In Pre-Seed Funding',
  //   link: 'https://scoopempire.com/sylndr-raises-12-6m-pre-seed/',
  // },
  // {
  //   news_media_name: 'EgyptBusiness',
  //   logo_image: 'egyptbusinessLogo.png',
  //   header_image: 'TechCrunchHeaderImage.png',
  //   text: 'Sylndr, is set to build trust in the used-car market by providing customers with a hassle-free experience to buy, sell and finance their cars.',
  //   link: 'https://www.egypt-business.com/web/details/2221-sylndr-egypts-online-used-car-retailer-raises-126m-in-a-pre-seed-round/423379',
  //   style: { backgroundColor: '#33a4ce' },
  // },
];
export const NewsAr = [
  {
    news_media_name: 'Forbes',
    logo_image: 'Forbeslogoblack.png',
    header_image: 'DisruptHeaderImage.jpg',
    text: 'Egypt’s Online Used Car Retailer Sylndr Raises $12.6M In Latest Funding Round',
    link: 'https://www.forbesmiddleeast.com/innovation/startups/egypts-online-used-car-retailer-sylndr-raises-%24126m-in-pre-seed-funding-round',
    logo_key: 'Forbeslogoblack',
    header_key: 'DisruptHeaderImage',
  },
  {
    news_media_name: 'Almal',
    logo_image: 'almalLogo.png',
    header_image: 'TechCrunchHeaderImage.png',
    text: 'سيلندر المصرية لتجارة السيارات المستعملة تجمع 12.6 مليون دولار في جولة تمويل بقيادة رائد فنتشرز السعودية',
    link: 'https://almalnews.com/%D8%B3%D9%8A%D9%84%D9%86%D8%AF%D8%B1-%D8%AA%D8%AC%D9%85%D8%B9-12-6-%D9%85%D9%84%D9%8A%D9%88%D9%86-%D8%AF%D9%88%D9%84%D8%A7%D8%B1-%D9%81%D9%8A-%D8%A3%D9%88%D9%84%D9%89-%D8%AC%D9%88/',
    logo_key: 'AlAmalLogo',
    header_key: 'TechCrunchHeaderImage',
  },
  {
    news_media_name: 'Waya',
    logo_image: 'waya.png',
    header_image: 'DisruptHeaderImage.jpg',
    text: 'سيلندر المصرية تجمع 12.6 مليون دولار في جولة تأسيسية',
    link: 'https://waya.media/arabi/%D8%B3%D9%8A%D9%84%D9%86%D8%AF%D8%B1-%D8%A7%D9%84%D9%85%D8%B5%D8%B1%D9%8A%D8%A9-%D8%AA%D8%AC%D9%85%D8%B9-12-6-%D9%85%D9%84%D9%8A%D9%88%D9%86-%D8%AF%D9%88%D9%84%D8%A7%D8%B1-%D9%81%D9%8A-%D8%AC%D9%88/',
    logo_key: 'Waya',
    header_key: 'DisruptHeaderImage',
  },
  //   {
  //     news_media_name: 'Zawya',
  //     logo_image: 'ZawyaLogo.png',
  //     header_image: 'ZawyaHeaderImage.jpg',
  //     text: 'Egypt’s used-car online retailer Sylndr raises $12.6mln in pre-seed round',
  //     link: 'https://www.zawya.com/en/wealth/alternative-investments/egypts-used-car-online-retailer-sylndr-raises-126mln-in-pre-seed-wdcgb8uw',
  //   },
  {
    news_media_name: 'Wamda',
    logo_image: 'wamdaLogo.png',
    header_image: 'DisruptHeaderImage.jpg',
    text: 'Sylndr raises $12.6 million pre-Seed round to scale its marketplace for used cars',
    link: 'https://www.wamda.com/ar/2022/05/sylndr-raises-12-6-million-pre-seed-round-scale-marketplace-used-cars-arabic',
    logo_key: 'WamdaLogo',
    header_key: 'DisruptHeaderImage',
  },
];
